import styled from "@emotion/styled";
import React from "react";
import { Page } from "../../activities/AppPage";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { INFO_CIRCLE_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";
import AppSlideFadeIn from "../Generic/AppSlideFadeIn";
import SafeArea from "../Generic/SafeArea";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";
import CareMomentsIntroAnimation from "./components/CareMomentsIntroAnimation";
import CareMomentsIntroButton from "./components/CareMomentsIntroButton";
import CareMomentsIntroInstructionsCard from "./components/CareMomentsIntroInstructionsCard";

type Props = {
  onRequestNavigate: (page: Page) => void;
  onClickGoBack: () => void;
};

export default function CareMomentsIntroScreen(props: Props) {
  return (
    <Scaffold.Root>
      <Scaffold.Header overlay={true}>
        <Scaffold.HeaderContent>
          <Scaffold.HeaderMainAction onClickGoBack={props.onClickGoBack} />
          <Scaffold.HeaderTitle>
            <ScaffoldTitle label={translate(STRINGS.CARE_MOMENTS)} />
          </Scaffold.HeaderTitle>
          <Scaffold.HeaderActions>
            <AppIcon
              icon={INFO_CIRCLE_ICON}
              size={16}
              onClick={() => props.onRequestNavigate({ type: "CareMomentsExplained" })}
              style={{ animation: "slideFadeIn 0.3s ease 3s backwards" }}
            />
          </Scaffold.HeaderActions>
        </Scaffold.HeaderContent>
      </Scaffold.Header>

      <Scaffold.Body>
        <AppSlideFadeIn delay={3000}>
          <SafeArea top={true}>
            <Heading>{translate(STRINGS.WELCOME_TO_CARE_MOMENTS)}</Heading>
          </SafeArea>
        </AppSlideFadeIn>

        <Scaffold.Context>
          {({ scrollRef }) => <CareMomentsIntroAnimation scrollRef={scrollRef} />}
        </Scaffold.Context>

        <AppSlideFadeIn delay={3000}>
          <CareMomentsIntroInstructionsCard />
        </AppSlideFadeIn>

        <BottomSpace />
      </Scaffold.Body>

      <AppSlideFadeIn delay={3000} asChild>
        <Scaffold.Footer>
          <CareMomentsIntroButton onRequestNavigate={props.onRequestNavigate} />
        </Scaffold.Footer>
      </AppSlideFadeIn>
    </Scaffold.Root>
  );
}

const BottomSpace = styled.div`
  height: 16px;
`;

const Heading = styled.h2`
  font-size: 22px;
  font-weight: 800;
  margin: 16px 0;
  text-align: center;
  padding: 8px 0;
  margin-top: 72px;
`;
